/** @jsxImportSource @emotion/react */

const Styles = {
  logoStyle: {
    lineHeight: '56px',
    zIndex: 2,
    whiteSpace: 'nowrap',
    color: '#FFFFFF',
    fontWeight: '600',
  },
  middleBar: {
    top: '56px',
    left: '0',
    right: '0',
    height: '45px',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: '3000',
    position: 'fixed',
    paddingRight: '30px',
    borderBottom: '1px solid #d9d9d9',
    backgroundColor: '#ffffff',
    button: {
      '&:hover': { backgroundColor: 'transparent' },
    },
    '& .MuiFormControl-root-MuiTextField-root': {
      verticalAlign: 'middle !important',
    },
    '& .MuiFormControl-root': {
      verticalAlign: 'middle !important',
      marginTop: '5px',
    },
  },
  rightElementStyle: { alignSelf: 'flex-end' },
  searchElementStyle: { alignSelf: 'flex-end' },
  fillElementStyle: { alignSelf: 'flex-start', flexGrow: 4 },
}

export default Styles
